import { TFacility, TFixtureLabels } from "components/Fixtures/Fixtures.types";
import RichText from "../RichText";
import React from "react";
import PackageRooms from "../PackageRooms";
import MediaCarousel from "../MediaCarousel";

type TFacilityContentProps = {
  onPreviousClick: () => void;
  onNextClick: () => void;
  facility: TFacility;
  position: number;
  domain: string;
  labels: TFixtureLabels;
  renderPrice: (
    price: number,
    fractionDigitsCount: number,
    formatText: string
  ) => string;
  hideArrows: boolean;
  prevFacilityName: string;
  nextFacilityName: string;
};

const onQuickLinkClick = (id: string) => {
  const element = document.getElementById(id);

  if (element) {
    let yOffset = 0;

    if (window.innerWidth <= 768) {
      // For mobile devices
      yOffset = -50;
    } else {
      // For desktop devices
      yOffset = -150;
    }

    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

const PACKAGE_OPTIONS_ID = "package-options";

function FacilityContent({
  onPreviousClick,
  onNextClick,
  facility,
  position,
  domain,
  labels,
  renderPrice,
  hideArrows,
  prevFacilityName,
  nextFacilityName,
}: TFacilityContentProps) {
  return (
    <div className="o-facility-content">
      <div className="o-facility-content__heading-wrapper">
        <div
          className="o-facility-content__heading"
          id="facility-navigation-item"
          style={hideArrows ? { justifyContent: "center" } : {}}
        >
          {!hideArrows && (
            <div className="o-facility-content__heading-arrow">
              <button onClick={onPreviousClick}>
                <i className="zmdi zmdi-long-arrow-left"></i>
              </button>
              <span>{`${prevFacilityName}`}</span>
            </div>
          )}
          <h4>{`${position}. ${facility.title}`}</h4>
          {!hideArrows && (
            <div className="o-facility-content__heading-arrow">
              <span>{`${nextFacilityName}`}</span>
              <button onClick={onNextClick}>
                <i className="zmdi zmdi-long-arrow-right"></i>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="o-facility-content__inner">
        <MediaCarousel items={facility.MediaList} />

        {facility.ContentTags && facility.ContentTags.length > 0 && (
          <div className="o-facility-content__links-wrapper">
            {facility.ContentTags.map((tag, index) => (
              <div className="o-facility-content__tag">
                <span key={index}>{tag}</span>
              </div>
            ))}
          </div>
        )}

        {labels.isWimbledon ? (
          <div className="o-facility-content__wimbledon-price">
            {renderPrice(facility.price, 0, labels.wimbledonPriceFormatText) +
              " " +
              facility.vatText}
          </div>
        ) : (
          <></>
        )}

        <RichText content={facility.description} />

        {labels.isWimbledon && (
          <a
            className="o-fixture-package__action-btn o-fixture-package__action-btn--solid"
            href={facility.wimbledonFacilitySelectLink}
            style={{ alignSelf: "flex-start" }}
          >
            <span>
              {facility.isTicketOnlyFacility
                ? labels.selectTicketLinkText
                : labels.selectFacilityLinkText}
            </span>
            <i className="zmdi zmdi-long-arrow-right"></i>
          </a>
        )}

        {labels.moreinformationlabel && (
          <div className="o-facility-content__links">
            <div
              className="o-facility-content__more"
              onClick={() => onQuickLinkClick("more-information")}
            >
              <svg
                className="o-facility-content__icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.1875 8.59375L9.99859 11.875L12.8125 8.59375"
                  stroke="#242425"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{labels.moreinformationlabel}</span>
            </div>
          </div>
        )}

        {/* <div className="o-facility-content__links">
          <span>{labels.quickLinksText}</span>
          <div className="o-facility-content__links-wrapper">
            {!labels.isWimbledon ? (
              <div
                className="o-facility-content__links-item"
                onClick={() => onQuickLinkClick(PACKAGE_OPTIONS_ID)}
              >
                <span>{labels.packageOptionsText}</span>
                <i className="zmdi zmdi-ticket-star"></i>
              </div>
            ) : (
              <></>
            )}
            {facility.content.map((content, index) => (
              <div
                className="o-facility-content__links-item"
                onClick={() => onQuickLinkClick(content.id)}
                key={`quick-link-${content.id}-${index}`}
              >
                <span>{content.title}</span>
                {content.icon && (
                  <i className={`zmdi zmdi-${content.icon}`}></i>
                )}
              </div>
            ))}
          </div>
        </div> */}

        {!labels.isWimbledon ? (
          <>
            <hr />
            <div className="o-facility-content__title" id={PACKAGE_OPTIONS_ID}>
              <span>{labels.packageOptionsText}</span>
              <i className="zmdi zmdi-ticket-star"></i>
            </div>

            <PackageRooms
              key={position}
              domain={domain}
              facility={facility}
              labels={labels}
              renderPrice={renderPrice as any}
            />
          </>
        ) : (
          <></>
        )}

        <div
          id="more-information"
          style={{ display: "block", height: "5px" }}
        ></div>

        {facility.content.map((content, idx) => {
          return (
            <React.Fragment key={idx}>
              <hr />
              {(content.title || content.icon) && (
                <div className="o-facility-content__title" id={content.id}>
                  {content.title && <span>{content.title}</span>}
                  {content.icon && (
                    <i className={`zmdi zmdi-${content.icon}`}></i>
                  )}
                </div>
              )}
              <RichText content={content.richText} />
              <MediaCarousel items={content.MediaContent} />
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default FacilityContent;
